/* Defer a Swiper init until its container nears the viewport (300px margin).
   Falls back to immediate init when IntersectionObserver is unavailable. */
function initNearView(el, init) {
  if (!el) return;
  if (!('IntersectionObserver' in window)) { init(); return; }
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { io.disconnect(); init(); }
  }, { rootMargin: '300px 0px' });
  io.observe(el);
}


/* Stop a continuous-autoplay Swiper while it is off screen — it otherwise
   animates (and burns main-thread) for the whole page lifetime. */
function pauseOffscreen(el, sw) {
  if (!el || !sw || !sw.autoplay || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { sw.autoplay.start(); }
    else { sw.autoplay.stop(); }
  }, { rootMargin: '100px 0px' });
  io.observe(el);
}

jQuery(document).ready(function () {

  fetch("/discount/CLEAR");
  
  $(".main-gallery video[autoplay]").each(function() {
    var video = this;
    var playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(function() {
        // Autoplay blocked → play on first tap
        $(document).one("touchstart", function() {
          video.play();
        });
      });
    }
  });

  /*
  * Name: Hide the subscription widget based from customer's ip address country location
  * Fallback: Shopify market geo redirect
  */
  // $(window).on('load', function () {
  //   $('body').removeClass('body-non-au');
  
  //   const apiKey = '6be9e5e33b3f9ee33ee7ebd401a82a65472dc1f1';
  //   const geoApiUrl = `https://api.getgeoapi.com/v2/ip/check?api_key=${apiKey}&format=json`;
  //   const allowedCountries = ['AU','NZ','PH'];
  //   const storageKey = 'user_country_code';
  //   const expiryKey = 'user_country_code_expiry';
  //   const ttlHours = 4;
  
  //   function applySubscriptionChanges() {
  //     $('body').addClass('body-non-au');
  //     $('#fon-onetime-option').trigger('click');
  //     $('#fon-subscription-options,.fon-subscription-option-seperator').hide();
  //   }
  
  //   function handleCountry(countryCode) {
  //     console.log(`[handleCountry] Country code is "${countryCode}".`);
  //     if (!allowedCountries.includes(countryCode)) {
  //       console.log(`[handleCountry] "${countryCode}" is NOT allowed. Applying changes.`);
  //       applySubscriptionChanges();
  //     } else {
  //       console.log(`[handleCountry] "${countryCode}" is allowed (AU or PH). No changes needed.`);
  //     }
  //   }
  
  //   function isExpired() {
  //     const expiry = localStorage.getItem(expiryKey);
  //     const now = Date.now();
  //     if (!expiry) {
  //       console.log('[isExpired] No expiry found in localStorage.');
  //       return true;
  //     }
  //     const isExpired = now > parseInt(expiry, 10);
  //     console.log(`[isExpired] Now: ${now}, Expiry: ${expiry}, Expired: ${isExpired}`);
  //     return isExpired;
  //   }
  
  //   function saveCountryToStorage(countryCode) {
  //     const expiryTime = Date.now() + ttlHours * 60 * 60 * 1000;
  //     localStorage.setItem(storageKey, countryCode);
  //     localStorage.setItem(expiryKey, expiryTime.toString());
  //     console.log(`[saveCountryToStorage] Stored "${countryCode}" with expiry at ${new Date(expiryTime).toLocaleString()}`);
  //   }
  
  //   function fetchAndStoreCountry() {
  //     console.log('[fetchAndStoreCountry] Fetching country via GeoAPI...');
  //     $.getJSON(geoApiUrl)
  //       .done(function (data) {
  //         let countryCode = null;
  
  //         if (data.status === 'success' && data.country && data.country.code) {
  //           countryCode = data.country.code;
  //           console.log(`[GeoAPI] Success: Country code from API: "${countryCode}"`);
  //         } else if (typeof Shopify !== 'undefined' && Shopify.country) {
  //           countryCode = Shopify.country;
  //           console.log(`[GeoAPI] Failed. Fallback to Shopify.country: "${countryCode}"`);
  //         } else {
  //           console.log('[GeoAPI] No country code found.');
  //         }
  
  //         if (countryCode) {
  //           saveCountryToStorage(countryCode);
  //           handleCountry(countryCode);
  //         }
  //       })
  //       .fail(function () {
  //         console.warn('[GeoAPI] API call failed.');
  //         if (typeof Shopify !== 'undefined' && Shopify.country) {
  //           const fallbackCountry = Shopify.country;
  //           console.log(`[GeoAPI] Fallback to Shopify.country: "${fallbackCountry}"`);
  //           saveCountryToStorage(fallbackCountry);
  //           handleCountry(fallbackCountry);
  //         } else {
  //           console.warn('[GeoAPI] No fallback available.');
  //         }
  //       });
  //   }
  
  //   const storedCountry = localStorage.getItem(storageKey);
  
  //   if (storedCountry && !isExpired()) {
  //     console.log(`[LocalStorage] Found valid country: "${storedCountry}".`);
  //     handleCountry(storedCountry);
  //   } else if (storedCountry && isExpired()) {
  //     console.log('[LocalStorage] Expired data. Fetching new data...');
  //     fetchAndStoreCountry();
  //   } else {
  //     console.log('[LocalStorage] No data found. Fetching...');
  //     fetchAndStoreCountry();
  //   }
  // });




  $(window).on("scroll", function() {
    var checkoutBtn = $("#fon-checkout-button");

    if (checkoutBtn.length) {
      var scrollTop = $(window).scrollTop();
      var checkoutOffset = checkoutBtn.offset().top;

      if (scrollTop > checkoutOffset) {
        $("body").addClass("scrolled-add-to-cart");
      } else {
        $("body").removeClass("scrolled-add-to-cart");
      }
    }
  });


  if ($(window).outerWidth() >= 768){
    $('#onefit-all-gallery').stickySidebar({
        topSpacing: 110,
        bottomSpacing: 60
    });
  }


  let mainSwiper;

  function initSwiper() {
    if (window.innerWidth >= 400 && !mainSwiper) {
      mainSwiper = new Swiper(".main-gallery", {
        loop: false,
        spaceBetween: 10,
        navigation: false, // default: hidden on desktop
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });


      // Thumbnail click navigation
      const $thumbs = $(".thumb");
      $thumbs.each(function (index) {
        $(this).on("click", function () {
          mainSwiper.slideToLoop(index);
        });
      });

        // Initial active thumb
        setActiveThumb(mainSwiper);

        // Update active thumb on slide change
        mainSwiper.on("slideChange", function () {
          setActiveThumb(mainSwiper);
        });
        

      // Sync active thumbnail
      function setActiveThumb(swiper) {
        $thumbs.removeClass("active");
        if (swiper && swiper.realIndex){
          const realIndex = swiper.realIndex;
          $thumbs.eq(realIndex).addClass("active");
        }
      }

    } else if (window.innerWidth < 788 && mainSwiper) {
      // Destroy if going back to mobile
      mainSwiper.destroy(true, true);
      mainSwiper = null;
    }
  }

  // Run on load
  initSwiper();

  // Run on resize
window.addEventListener("resize", initSwiper);





 // Flavour options
 

  $(document).on('click','#fon-oos-button',function(){

      var variantID = $('.fon-flavour.active').attr('data-variant-id');
      $.magnificPopup.open({
        items: {
          src: '.klaviyo-oos-' + variantID // This is the ID of the hidden div
        },
        type: 'inline'
      });

  });


  var flavourClick  = 0;
  $(".flavour-options > div").not(".fon-flavour-oos").on("click", function () {
  // $(".flavour-options > div").on("click", function () {

    
    if ($(this).hasClass('fon-flavour-oos')){
      $('body').addClass('selected-variant-oos');
      $('#fon-oos-button').addClass('active');
    }else{
      $('body').removeClass('selected-variant-oos');
      $('#fon-oos-button').removeClass('active');
    }

    flavourClick++;

    // Reset siblings
    $(this).siblings()
      .removeClass("active");

    // Activate this one
    $(this)
    .addClass("active")
    .find(".flavour-color")
    .css({
      "background-color": $(this).data("color"),
      "border-color": $(this).data("color")
    });
    
    // if (isLightColor($(this).data("color"))) {
    //   $(this).addClass("light");
    // }

    var parent = $(this).parents('.fon-packaging-wrapper');

    var selectedVariantText = parent.find('.fon-flavour.active').attr('data-text');
    parent.next('.flavour-label').html(selectedVariantText);


    // Product Gallery
    if (flavourClick > 1){
      // updateImage();
    }
    

    checkSelections();
  });


  function updateImage(){
      var selectedVariantID = $('.fon-flavour.active').attr('data-variant-id');
      var selectedVariantImage = $('.fon-flavour.active').attr('data-variant-image');
      var selectedVariantVideo = $('.fon-flavour.active').attr('data-variant-video');
      var selectedVariantImageMobile = $('.fon-flavour.active').attr('data-variant-image-mobile');

      var selectedVariantSecondaryImage = $('.fon-flavour.active').attr('data-variant-secondary-image-desktop');
      var selectedVariantSecondaryImageMobile = $('.fon-flavour.active').attr('data-variant-secondary-image-mobile');


      var selectedVariantSubscriptionImage = $('.fon-flavour.active').attr('data-variant-subscription-image');
      var selectedVariantSubscriptionImageMobile = $('.fon-flavour.active').attr('data-variant-subscription-image-mobile');

      // alert(selectedVariantSecondaryImage);

      if ($('#fon-subscription-options').hasClass('active') && selectedVariantSubscriptionImage){
        $('.thumb-first img').attr('src',selectedVariantSubscriptionImage);
        $('.swiper-slide-first .slide-video-image').html(`
            <picture>
              <source media="(max-width: 767px)" srcset="${selectedVariantSubscriptionImageMobile}">
              <img src="${selectedVariantSubscriptionImage}" class="img-fluid" alt="OneFit">
            </picture>
        `);
      }else{
        $('.thumb-first img').attr('src',selectedVariantImage);
        $('.swiper-slide-first .slide-video-image').html(`
            <picture>
              <source media="(max-width: 767px)" srcset="${selectedVariantImageMobile}">
              <img src="${selectedVariantImage}" class="img-fluid" alt="OneFit">
            </picture>
        `);
      }
      

    
      $('.swiper-slide-secondary .slide-video-image').html(`
          <picture>
            <source media="(max-width: 767px)" srcset="${selectedVariantSecondaryImageMobile}">
            <img src="${selectedVariantSecondaryImage}" class="img-fluid" alt="OneFit">
          </picture>
      `);
    }

   

  // var selectedOrFirstAvailableVariantID = $('.flavour-options').attr('data-active-variant');
  // $(`.fon-flavour[data-variant-id="${selectedOrFirstAvailableVariantID}"]`).click();
  // checkSelections();

 

  // Packaging options
  $("#packaging-options .fon-packaging").on("click", function () {


    
    $("#packaging-options .fon-packaging").removeClass("active");
    $(this).addClass("active");

    // Hide all flavour option groups
    // Hide all flavour option groups
  $(".flavour-options").removeClass("active")
  .find("div").removeClass("active")
  .css("background-color", "inherit")           // reset parent div

    // Show the matching flavour options
    const packaging = $(this).data("packaging");
    $(`#flavour-options-${packaging}`).addClass("active");
    
    checkSelections();

  });

  // Quantity picker
  $("#quantity-options > div").on("click", function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    checkSelections();
  });

  // Paying options
  $("#paying-options > div").on("click", function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    checkSelections();
  });


  checkSelections();

  function checkSelections(){
      checkVariantOption();
      checkPrices();
      checkCheckout();
      checkAfterPay();

      // Floating add to cart
      var originalPrice = $('#fon-subscription-options').find('.original-price').html();
      var salePrice = $('#fon-subscription-options').find('.sale-price').html();


      $('.onefit-all-subscribe-save .save-new-price .price').html(salePrice);
      $('.onefit-all-subscribe-save .save-old-price .price').html(originalPrice);
      $('.onefit-all-onetime-only .save-new-price .price').html(originalPrice);

      if ($('#fon-subscription-options').hasClass('active')){
        $('.onefit-all-subscribe-save').show();
        $('.onefit-all-onetime-only').hide();
      }else{
        $('.onefit-all-subscribe-save').hide();
        $('.onefit-all-onetime-only').show();
      }


      $('.dynamic-selected-flavour-pouch').html($('.pouches-wrapper .fon-flavour.active').attr('data-variant-title'));
      $('.dynamic-selected-flavour-sachets').html($('.sachets-wrapper .fon-flavour.active').attr('data-variant-title'));
      

      $('.dynamic-selected-quantity').html($('.fon-quantity-picker.active').find('p').html());
      

      if ($('div#fon-subscription-options').hasClass('active')){
        $('.dynamic-selected-price').html('Subscription');
      }else{
        $('.dynamic-selected-price').html('One-time');
      }

  }

  function checkAfterPay(){

      var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');
      if (activePaymentPlan == 'subscription'){
        $('.afterpay-text').hide();
      }else{
        $('.afterpay-text').show();
      }

  }
  function checkCheckout(){
    var checkoutButton = $('#fon-checkout-button');
    if ($('.fon-quantity-picker.active').length && $('.flavour-options > div.active').length){
      checkoutButton.prop('disabled',false);
    }else{
      checkoutButton.prop('disabled',true);
    }
  }


$(document).on('click', '#fon-checkout-button, .btn-floating-add-to-cart', function () {
  var $btn = $(this);

  // Example: set these booleans elsewhere in your script or from Shopify API
  // var bottleOOS = false;
  // var frotherOOS = true;

  var qty = parseInt($('.fon-quantity-picker.active').attr('data-qty'), 10) || 1;
  var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');

  // 🔹 1️⃣ Initialize formData
  var formData = { items: [] };

  const _bundle_group_id = Math.floor(Date.now() / 1000);


  // 🔹 2️⃣ Loop through all active flavours and add main flavour items
  var bundleRow = 1;
  $('.flavour-options > div.active').each(function () {
    var $variant = $(this);

    var title = 'OneFit ' + $variant.find('.flavour-title').attr('data-title');
    var variantID = $variant.attr('data-variant-id');
    var variantSellingPlanID = $variant.attr('data-selling-plan-id');

    if (!variantID) return; // Skip if invalid

    // 🧩 Main flavour item
    var item = {
      id: variantID,
      quantity: qty,
      properties: {
        "_BUNDLE": "Pouch & Sachets",
        "BUNDLE ID" : _bundle_group_id,
        "_bundle_group_product" : true,
        "_bundle_group_product_row" : bundleRow,
        "_bundle_group_id" : _bundle_group_id,
        "_bundle_group_payment_type" : $('.fon-subscription-option.active').attr('data-payment-option'),
        "_bundle_group_oneitem_price" : $('#fon-subscription-options .original-price').html(),
        "_bundle_group_sale_price" : $('#fon-subscription-options .sale-price').html(),
        "_bundle_group_image" : $('.slide-video-image img').attr('src'),
      }
    };

    // Add selling plan if subscription selected
    if (activePaymentPlan === 'subscription' && variantSellingPlanID) {
      item.selling_plan = variantSellingPlanID;
    }

    // Add to formData
    formData.items.push(item);
    bundleRow++;
  });

  // // 🔹 3️⃣ Add Welcome Kit items only if in stock
  // if (typeof bottleOOS !== 'undefined' && bottleOOS === false) {
  //   formData.items.push({
  //     id: bottlePriceVariantID,
  //     quantity: 2,
  //     properties: {
  //       "BUNDLE": "Pouch and Sachets",
  //       "_bundle_group_id" : _bundle_group_id,
  //       "_bundle_group_add_on" : true,
  //     }
  //   });
  // }

  // if (typeof frotherOOS !== 'undefined' && frotherOOS === false) {
  //   formData.items.push({
  //     id: frotherPriceVariantID,
  //     quantity: 1,
  //     properties: {
  //       "BUNDLE": "Pouch & Sachets",
  //       "_bundle_group_id" : _bundle_group_id,
  //       "_bundle_group_add_on" : true,
  //     }
  //   });
  // }


    var cartDiscountCode = '';
  
  // Add selling plan if subscription is selected
  if (activePaymentPlan === 'subscription') {
    cartDiscountCode = 'Pouch and Sachets / Subscription';
  }else{
    cartDiscountCode = 'Pouch and Sachets / One-time';
  }



  // Disable button & show loading state
  var originalText = $btn.text();
  $btn.text('Preparing your bundle...').prop('disabled', true);

  // Step 1: Clear the cart
  // $.ajax({
  //   type: 'POST',
  //   url: '/cart/clear.js',
  //   dataType: 'json',
  //   success: function () {
  //     console.log('Cart cleared.');

      // Step 2: Add all items
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(formData),
        dataType: 'json',
        contentType: 'application/json',
        success: function (response) {
          console.log('Items added:', response);

          // Step 3: Add a cart attribute for WELCOME KIT
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: JSON.stringify({
              attributes: {
                "BUNDLE": "Pouch & Sachets"
              }
            }),
            dataType: 'json',
            contentType: 'application/json',
            success: function () {
              console.log('Cart attribute added: WELCOME KIT');

              // ✅ Step 4: Redirect to checkout
              // window.location.href = '/checkout?discount=' + cartDiscountCode;

              // ✅ Update and open cart drawer
              if (typeof FonCartDrawer !== 'undefined') {
                FonCartDrawer.updateCartDrawer();
                FonCartDrawer.openCartDrawer();
              }

              $btn.text(originalText).prop('disabled', false);

            },
            error: function (xhr, status, error) {
              console.error('Error adding cart attribute:', error);
              alert('Items added, but failed to tag cart. Proceeding to checkout.');
              // window.location.href = '/checkout?discount=' + cartDiscountCode;

              // ✅ Update and open cart drawer
              if (typeof FonCartDrawer !== 'undefined') {
                FonCartDrawer.updateCartDrawer();
                FonCartDrawer.openCartDrawer();
              }

              $btn.text(originalText).prop('disabled', false);

            }
          });
        },
        error: function (xhr, status, error) {
          console.error('Error adding items:', error);
          $btn.text(originalText).prop('disabled', false);
          alert('Failed to add products. Please try again.');
        }
      });
//     },
//     error: function (xhr, status, error) {
//       console.error('Error clearing cart:', error);
//       $btn.text(originalText).prop('disabled', false);
//       alert('Failed to clear cart. Please try again.');
//     }
//   });
});


//   $(document).on('click', '#fon-checkout-button, .btn-floating-add-to-cart', function () {
//     var $btn = $(this);

//     // Collect selected values
//     var quantityElement = $('.fon-quantity-picker.active');
//     var qty = parseInt(quantityElement.attr('data-qty'));

//     var selectedVariant = $('.flavour-options > div.active');
//     var variantID = selectedVariant.attr('data-variant-id');
//     var variantSellingPlanID = selectedVariant.attr('data-selling-plan-id');

//     var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');

//     // Prepare data for Shopify AJAX API
//     var formData = {
//       items: [
//         {
//           id: variantID,
//           quantity: qty
//         }
//       ]
//     };

//     if (activePaymentPlan === 'subscription' && variantSellingPlanID) {
//       formData.items[0].selling_plan = variantSellingPlanID;
//     }

//     // Disable button & show loading state
//     var originalText = $btn.text();
//     $btn.text('Adding...').prop('disabled', true);

//     // AJAX add to cart
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: JSON.stringify(formData),
//       dataType: 'json',
//       contentType: 'application/json',
//       success: function (response) {
//         console.log('Added to cart:', response);

//         // ✅ Update and open cart drawer
//         if (typeof FonCartDrawer !== 'undefined') {
//           FonCartDrawer.updateCartDrawer();
//           FonCartDrawer.openCartDrawer();
//         }

//         // ✅ Revert button
//         $btn.text(originalText).prop('disabled', false);
//       },
//       error: function (xhr, status, error) {
//         console.error('Error:', error);

//         // ❌ Revert button
//         $btn.text(originalText).prop('disabled', false);
//         alert('Something went wrong. Please try again.');
//       }
//     });
//   });


function checkPrices() {
  // Run only if at least one active quantity + flavour
  if ($('.fon-quantity-picker.active').length && $('.flavour-options > div.active').length) {

    var totalOneTime = 0;
    var totalSubscription = 0;
    var activeQty = 0; //parseInt($('.fon-quantity-picker.active').attr('data-qty'), 10) || 1;

    // 1️⃣ Loop through all active flavours and sum prices
    $('.flavour-options > div.active').each(function() {
      var onetimePrice = parseFloat($(this).attr("data-one-time-price")) / 100 || 0;
      var subscriptionPrice = parseFloat($(this).attr("data-subscription-price")) / 100 || 0;

      totalOneTime += onetimePrice;
      totalSubscription += subscriptionPrice;
      activeQty++;
    });

    // Add on price
    var addOnPrice = 0;
    if (typeof bottleOOS !== 'undefined' && bottleOOS === false) {
      addOnPrice+= bottlePrice * 2;
    }

    if (typeof frotherOOS !== 'undefined' && frotherOOS === false) {
      addOnPrice+= frotherPrice;
    }
    

    // 2️⃣ Multiply totals by quantity first
    // totalOneTime = totalOneTime * activeQty;
    // totalSubscription = totalSubscription * activeQty;

    // 3️⃣ Apply discount based on quantity
    // switch (activeQty) {
    //   case 2:
    //     totalOneTime *= 0.95;  // 5% off
    //     totalSubscription *= 0.95;
    //     break;
    //   case 3:
    //     totalOneTime *= 0.90;  // 10% off
    //     totalSubscription *= 0.90;
    //     break;
    //   case 4:
    //     totalOneTime *= 0.85;  // 15% off
    //     totalSubscription *= 0.85;
    //     break;
    //   default:
    //     // No discount for 1 or >4
    //     break;
    // }


    // totalOneTime += addOnPrice;
    // totalOneTime -= 21.00 * Shopify.currency.rate; // converted value

    // totalSubscription += addOnPrice;
    // totalSubscription -= 42.00 * Shopify.currency.rate; // converted value

    

    // 4️⃣ Update UI
    

    if ($('.country-AU').length){
      $('div#fon-subscription-options .original-price').html(totalOneTime.toFixed(0));
      $('div#fon-subscription-options .sale-price').html(totalSubscription.toFixed(0));
      $('div#fon-onetime-option .sale-price').html(totalOneTime.toFixed(0));
    }else{
      $('div#fon-subscription-options .original-price').html(totalOneTime.toFixed(2));
      $('div#fon-subscription-options .sale-price').html(totalSubscription.toFixed(2));
      $('div#fon-onetime-option .sale-price').html(totalOneTime.toFixed(2));
    }
    


    

    // 5️⃣ Calculate and display savings
    var savePrice = totalOneTime - totalSubscription;
    $('#save-price, save-price').html(savePrice.toFixed(0)); // Works for either class or ID

    $('.option-heading .option-pricing').addClass('active');
    
  }
}


  function checkVariantOption(){

    
    if ($('.flavour-options > div.active').length){
      var activeSelection = $('.flavour-options > div.active');

      var onetimePrice = activeSelection.attr("data-one-time-price");
      var subscriptionPrice = activeSelection.attr("data-subscription-price");

      var priceBasis = onetimePrice / 100;


      var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');
      if (activePaymentPlan == 'subscription'){
        priceBasis = subscriptionPrice / 100;
      }
      

      var serveBasis = 20;

      if ($('.quantity-options-onelife').length){
        serveBasis = 30;
      }
      
      $(".fon-quantity-picker").each(function(index, element) {
        var qty = parseInt($(this).attr('data-qty'), 10);
        var perServeElement = $(this).find('.value');
        var perServeValue = 0;


        switch (qty){
          case 1:
            perServeValue = priceBasis / serveBasis;
          break;
          case 2:
            perServeValue = (priceBasis * qty * 0.95) / (serveBasis * qty);
          break;
          case 3:
            perServeValue = (priceBasis * qty * 0.90) / (serveBasis * qty);
          break;
          case 4:
            perServeValue = (priceBasis * qty * 0.85) / (serveBasis * qty);
          break;
        }

        perServeElement.html(perServeValue.toFixed(2));
      });

      // updateImage();

    }

  }


  $(document).on('click', '.fon-accordion-heading', function () {
    // Remove active from all others
    $('.fon-accordion-heading').not(this).removeClass('active');

    // Toggle only the clicked one
    $(this).toggleClass('active');
  });


  initNearView(document.querySelector('.reviews-swiper'), function () {
  var swiper = new Swiper(".reviews-swiper", {
    slidesPerView: 1, // default for desktop
    spaceBetween: 20,
    grabCursor: true,
    loop: true,
    centeredSlides: true, // turned off grid-style center mode
    breakpoints: {
      // when window width is <= 768px (tablet & below)
      768: {
        slidesPerView: 3
      }
    }
  });
  });

  initNearView(document.querySelector('.swiper-of-all-hall'), function () {
  var swiperHallOfFame = new Swiper(".swiper-of-all-hall", {
    slidesPerView: 1.2,
    spaceBetween: 42,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 42
      }
    }
  });
  });
  initNearView(document.querySelector('.swiper-of-all-hall-mobile'), function () {
  var swiperHallOfFame = new Swiper(".swiper-of-all-hall-mobile", {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });
  });

  // $('.open-supplement-facts').magnificPopup({
  //   type: 'inline',
  //   midClick: true, // allow opening popup on middle mouse click
  //   closeBtnInside: true,
  //   removalDelay: 300,
  //   mainClass: 'mfp-fade'
  // });

  $('.open-supplement-facts').magnificPopup({
    type: 'inline',
    callbacks: {
          open: function() {
              console.log('Popup body-inline-bottom');
              $('body').addClass('body-popup-slide');
          },
          close: function() {
              console.log('Popup closed');
              $('body').removeClass('body-popup-slide');
          }
    },
    mainClass: 'mfp-animate-bottom',
    closeMarkup: `
      <button title="%title%" type="button" class="mfp-close">
        <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
          <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
        </svg>
      </button>
    `
  });


  // Supplement Facts
  $(document).on("click", ".flavour-options-facts > div", function() {
    // remove active from siblings, add to clicked one
    $(this).addClass("active").siblings().removeClass("active");

    // check if clicked has .flavour-vegan
    if ($(this).hasClass("flavour-vegan")) {
      $(".protein-type").text("Pea Protein");
    } else {
      $(".protein-type").text("Organic Collagen Peptides");
    }
  });


  

  // Helper: check if color is light
  function isLightColor(hex) {
    if (!hex) return false;
    hex = hex.replace("#", "");

    // Expand shorthand (e.g. "fff" → "ffffff")
    if (hex.length === 3) {
      hex = hex.split("").map(c => c + c).join("");
    }

    var r = parseInt(hex.substr(0, 2), 16);
    var g = parseInt(hex.substr(2, 2), 16);
    var b = parseInt(hex.substr(4, 2), 16);

    // Perceived brightness (HSP)
    var brightness = Math.sqrt(
      0.299 * (r * r) +
      0.587 * (g * g) +
      0.114 * (b * b)
    );

    return brightness > 200; // threshold, tweak if needed
  }



  function initGallery($gallery) {
  $gallery.on('click', 'img, video', function (e) {
    e.preventDefault();

    var $clicked = $(this);
    var $items = $gallery.find('img, video');

    var promises = $items.map(function () {
      var $el = $(this);

      // VIDEO ITEM
      if ($el.is('video')) {
        return Promise.resolve({
          html:
            '<div style="display:flex;justify-content:center;align-items:center;width:100%;height:100%;">' +
              '<video autoplay muted loop playsinline preload="auto" ' +
              'style="max-width:100%;max-height:100%;width:auto;height:auto;">' +
                '<source src="' + $el.find('source').attr('src') + '" type="video/mp4">' +
                'Your browser does not support the video tag.' +
              '</video>' +
            '</div>',
          w: 1920,
          h: 1080
        });
      }

      // IMAGE ITEM (get original size)
      // <picture> carries no src — only its inner <img> does. Without this fallback
      // imgSrc is undefined, the browser requests /products/undefined (404), img.onload
      // never fires, Promise.all never settles and the lightbox never opens.
      var imgSrc = $el.data('large') || $el.attr('src') || $el.find('img').attr('src');
      return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () {
          resolve({
            src: imgSrc,
            w: img.naturalWidth,
            h: img.naturalHeight
          });
        };
        img.src = imgSrc;
      });
    }).get();

    Promise.all(promises).then(function (items) {
      var index = $items.index($clicked);
      var pswpElement = document.querySelector('.pswp');

      var options = {
        index: index,
        bgOpacity: 0.9,
        showHideOpacity: true,
        barsSize: { top:44, bottom:'auto' }, // space for top bar
        shareEl: false,                       // hide share if not needed
        fullscreenEl: false,                  // hide fullscreen if not needed
        zoomEl: false,                        // hide zoom if not needed
        counterEl: false,                     // hide counter if not needed
        arrowEl: true,                        // keep prev/next arrows
        closeEl: true,                        // ✅ show close button
        closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar'] // where it should render
      };

      var lightbox = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      lightbox.init();
    });
  });
}


  // Desktop gallery
  initGallery($('.product-main-gallery'));

  initNearView(document.querySelector('.onefit-all-marquee-swiper'), function () {
  const marqueeSwiper = new Swiper(".onefit-all-marquee-swiper", {
    slidesPerView: "auto",   // size slides to content
    spaceBetween: 30,        // spacing between
    loop: true,              // seamless repeat
    allowTouchMove: false,   // disable dragging
    speed: 10000,            // how long 1 loop takes (ms) → higher = slower
    autoplay: {
      delay: 0,              // no pause, continuous
      disableOnInteraction: false,
    },
  });
  pauseOffscreen(document.querySelector('.onefit-all-marquee-swiper'), marqueeSwiper);
  });

  // $('.fon-flavour-oos').on('click', function () {
  //   let $el = $(this);
  //   $el.addClass('wiggle');
    
  //   // remove after animation ends so it can trigger again
  //   setTimeout(() => {
  //     $el.removeClass('wiggle');
  //   }, 500); // match animation duration
  // });


  // All videos
  const videos = document.querySelectorAll('.onefit-all-videos video');

  // Intersection Observer to trigger play when visible
  let observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      if (entry.isIntersecting) {
        // Try autoplay unmuted
        video.muted = true;
        video.loop = true;
        video.play().catch(err => {
          console.log("Autoplay blocked:", err);
        });

        $('.onefit-all-videos img').fadeOut();
        $('.onefit-all-videos video-media').attr('loaded','true');

      } else {
        video.pause(); // optional: pause when out of view
      }
    });
  }, {
    threshold: 0.1 // at least 50% visible
  });

  videos.forEach(video => observer.observe(video));

  $('.onefit-all-videos .video-container').on('click', function () {
    const $container = $(this);
    const $video = $container.find('video').get(0);
    const $overlay = $container.find('.video-overlay');

    if ($video.muted) {
      // Mute all others and reset overlays
      $('.onefit-all-videos .video-container').each(function () {
        const v = $(this).find('video').get(0);
        v.muted = true;
        $(this).find('.video-overlay').show();
      });

      // Unmute clicked video + hide overlay
      $video.muted = false;
      $overlay.hide();

      if ($video.paused) {
        $video.play().catch(() => {});
      }
    } else {
      // Already unmuted → mute and show overlay
      $video.muted = true;
      $overlay.show();
    }
  });

  initNearView(document.querySelector('.swiper-add-to-cart-carousel'), function () {
  const addToCartSwiper = new Swiper('.swiper-add-to-cart-carousel', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true, // keep enabled for soft transition
    },
    loop: true,
    speed: 700, // shorter fade duration
    autoplay: {
      delay: 2000, // longer time before next transition
      disableOnInteraction: false,
    },
  });
  });





  checkDuoKitSelections();
  function checkDuoKitSelections(){
    
      $('.fon-packaging-wrapper').each(function() {

        var $wrapper = $(this);
        var $firstValidFlavour = $wrapper.find('.fon-flavour').not('.fon-flavour-oos').first();


        if ($firstValidFlavour.length) {
          $firstValidFlavour.trigger('click');
          checkSelections();
        }
      });

  }


});
